__turbopack_context__.v({
  "button": "vG_L7q_button",
  "scale-up": "vG_L7q_scale-up",
});
